/**
 * 吃饭睡觉补贴活动 - 常量定义
 */


export const COIN_ICON = {
  GOLD: 'https://m.hellobike.com/f52d7292_image%201319.png',
  GRAY: 'https://m.hellobike.com/f8f3ba17_image%201403.png',
};

export const BUTTON_BG = {
  ACTIVE: 'https://m.hellobike.com/80a7561bea.png',
  DISABLED: 'https://m.hellobike.com/1da8e4ec34.png',
};

export const CALENDAR_REMIND = {
  TITLE: '领起床补贴，每日奖励金等你拿',
  NOTES: 'hellobike://hellobike.com/openWeb?webUrl='
    + 'https%3A%2F%2Fm.hellobike.com%2FAppPlatformH5%2Flatest%2Findex.html%23'
    + '%2Fwelfare%2Fmeal-sleep-subsidy',
};

export const TEXT = {
  TOAST_TASK_FAILED: '任务未完成',
  TOAST_VIDEO_LOAD_FAILED: '拉取视频失败，请稍后再试',
  TOAST_CALENDAR_ADD_SUCCESS: '添加日历提醒成功',
  TOAST_CALENDAR_ADD_FAILED: '添加日历提醒失败',
  TOAST_CALENDAR_DELETE_SUCCESS: '已关闭日历提醒',
  TOAST_CALENDAR_DELETE_FAILED: '关闭日历提醒失败',
};
